module.exports = __webpack_public_path__ + "img/icon_xianshangyizhen.67b531aa.png";